import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbOffcanvasConfig, NgbOffcanvas, NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AttendanceService } from '../../../../../../core/services/attendance.service';
import { ClassroomService } from '../../../../../../core/services/classroom.service';
import { InscriptionFileService } from '../../../../../../core/services/inscription-file.service';
import { ProfessorAcademicClassroomService } from '../../../../../../core/services/professor-academic-classroom.service';
import { ProfessorCourseService } from '../../../../../../core/services/professor-course.service';
import { StudentAyClassroomService } from '../../../../../../core/services/student-ay-classroom.service';
import { AppSweetAlert } from '../../../../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../../core/utils/local-stoarge-service';
import {FileService as myFileService} from '../../../../../../core/utils/file-service'
import { PeriodService } from '../../../../../../core/services/period.service';
import { AppErrorShow } from '../../../../../../core/utils/app-error-show';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule, NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../../layout/includes/header/header.component';

@Component({
    selector: 'app-attendance-create',
    templateUrl: './attendance-create.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule,
        NgxPaginationModule,
        NgLabelTemplateDirective,
        NgOptionTemplateDirective,
        NgSelectComponent,
    ],
    styleUrls: ['./attendance-create.component.css']
})
export class AttendanceCreateComponent {
  classroomSelected=null
  buttonsPermission :any|undefined;
 search_text=""
  data:any[] =[]
  paccs:any[] =[]
  dows:any[] =[]
  classrooms:any[]=[]
  attendances:any[]=[]
  attendance_categories:any[]=[]
  categories:any[]=[]
  courses:any[]=[]
  periods:any[]=[]
  selected_data:any;
  is_valid=null
  loading=false
  paccId:any
  dow_id:any
  category:any
  periodId:any
  minDate=new Date('dd-MM-yyyyT06:00')
  maxDate=new Date('dd-MM-yyyyT30:00')
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  tag="admin-bvs-attendances-create"
  constructor(
    private attendanceService:AttendanceService,
    private paccService:ProfessorCourseService,
    private sacService:StudentAyClassroomService,
    private pacService:ProfessorAcademicClassroomService,
    private periodService:PeriodService,
    private router:Router,
    private classroomService:ClassroomService,
    private activatedRoute:ActivatedRoute,
    private _sanitizationService: DomSanitizer,
    configOffCanvas: NgbOffcanvasConfig,
     private offcanvasService: NgbOffcanvas,
     private toastrService: ToastrService,
     private insFileService:InscriptionFileService,
     private lsService:LocalStorageService,
     config: NgbModalConfig,
    private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
      
    configOffCanvas.position = 'end';
		configOffCanvas.backdropClass = 'bg-dark';
		configOffCanvas.keyboard = false;
   }
  ngOnInit(): void {
    this.buttonsPermission={
      show:true,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }

    this.attendances=this.lsService.get(GlobalName.features).attendances
    this.attendance_categories=this.lsService.get(GlobalName.features).attendance_categories
   this.getClassrooms()
   this.getPeriods()
  }

  getAll(){
    this.attendanceService.getAll().subscribe((res:any)=>{
      this.classrooms=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des présences",err)
    })
  }
  getClassrooms(){
    this.classroomService.getAll().subscribe((res:any)=>{
      this.classrooms=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des présences",err)
    })
  }
  getPeriods(){
    this.periodService.getAll().subscribe((res:any)=>{
      this.periods=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des présences",err)
    })
  }

  getPrograms(day_number:any){
    let check= this.data.find((el:any)=>el.day_number == day_number);
    return check!=null ?check?.programs : []
  }

  getPaccs(){
    this.courses=[]
    this.paccService.getAll(this.classroomSelected).subscribe((res:any)=>{
      this.paccs=res.data
      res.data.forEach((element:any) => {
        this.courses.push(...element.courses)
      });
      },
  (err:any)=>{
    AppErrorShow.showError("Gestion des présences",err)

  })
  }
  loadList(ev:any){
    this.data=[]
    if (ev=="Enseignant") {
      this.pacService.getAll(this.classroomSelected).subscribe((res:any)=>{
        res.data.forEach((element:any) => {
          this.data.push({
            identity:` ${element.professor?.lastname} ${element.professor?.firstname}`,
            type:this.attendance_categories[0],
            coming_time:null,
            motif:"",
            file:null,
            file64:null,
            motif_filename:"",
            pacc_id:this.paccId,
            concerned_id:element.id
          })
        });
        },
    (err:any)=>{
      AppErrorShow.showError("Gestion des présences",err)

    })
    } else {
      this.sacService.getAll(this.classroomSelected).subscribe((res:any)=>{
        res.data.forEach((element:any) => {
          this.data.push({
            identity:` ${element.student?.lastname} ${element.student?.firstname}`,
            type:this.attendance_categories[1],
            coming_time:null,
            motif:"",
            motif_filename:"",
            pacc_id:this.paccId,
            file:null,
            file64:null,
            concerned_id:element.id
          })
        });
        },
    (err:any)=>{
      AppErrorShow.showError("Gestion des présences",err)

    })
    }
  
  }

   upload(event:any,i:any){
    if(event.target.files.length!=0){
      let fileInput=event.target.files[0]
      this.addFile(fileInput,i)
      
    }
  }
  async addFile(fileInput:any,i:any){
    this.data[i].file=fileInput
      this.data[i].file64=await myFileService.fromArrayBufferToBase64(await myFileService.readFileAsync(fileInput))
  }
  removeFile(i:any){
    this.data[i].file=null
    this.data[i].file64=null
  }

  loadPacs(ev:any){
    this.classroomSelected=ev
    this.getPaccs()
  }


  loadCourses(ev:any){
    this.courses=this.paccs.find((el:any)=>el.id == ev.target.value).courses
  }
  setPaccId(ev:any){
    this.paccId=this.courses.find((el:any)=>el.id == ev.target.value).pivot.id
    console.log(this.paccId)
  }

  filterPrograms(element: any) {
    console.log(element)
    return element.programs
  }
  
  checked(el?:any){
    this.selected_data=el;
    this.is_valid=el.is_valid
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }
  
    show(){
    if(!this.verifyIfElementChecked()) return ;
    this.router.navigate(['/admin/inscription-details/'+this.selected_data.code])
  }


  delete(id:any){
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.attendanceService.delete(id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des permissions",err)

    })
  }
})
  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.paccService.setState(this.selected_data.code,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.getAll()
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Gestion des permissions",err)

      })
  }

  
  add(content:any, id:any){
    this.dow_id=id
    this.modalService.open(content,{size:'lg'});
  }

  store(){
    let data={
      category:this.category,
      period_id:this.periodId,
      details:this.data
    }

    // let d1 =formatDate(new Date(value.start_time),'hh:mm:ss','en_US');
    // let d2 =formatDate(new Date(value.end_time),'hh:mm:ss','en_US');
 
    //  if(d2 < d1){
 
    //    this.toastrService.error(`L'heure de fin ne peut pas être antérieure à l'heure de début`)
    //    return ;
    //  }


     
     this.loading=true

    // console.log(value)
    
    this.attendanceService.store(data).subscribe((res:any)=>{
        this.loading=false
        this.toastrService.success(res.message)
        this.router.navigate(['/admin/bvs-attendances-book'])
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des permissions",err)

    })
  }
}
